import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

import SurveyDialog from "../User/Create/SurveyDialog";
import { useTranslation } from "react-i18next";
import useClasses from "../useClasses";

const styles = (theme) => ({
  list: { padding: theme.spacing(0) },
  listItem: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  avatar: {
    backgroundColor: "transparent",
    color: theme.palette.text.primary,
    alignSelf: "flex-start",
    width: theme.spacing(4),
    height: theme.spacing(4),
    borderRadius: "30%",
  },
});

function AddSurvey() {
  const classes = useClasses(styles);
  const { t } = useTranslation();
  const [dialog, setDialog] = useState({ open: false });

  const handleOpen = () => setDialog({ open: true });
  const handleClose = () => setDialog({ open: false });

  return (
    <div>
      <Paper style={{ width: "100%" }}>
        <List className={classes.list}>
          <ListItem button onClick={handleOpen} className={classes.listItem}>
            <ListItemIcon>
              <Avatar aria-label="surveyAvatar" className={classes.avatar}>
                <AddCircleOutlineOutlinedIcon fontSize="small" />
              </Avatar>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography noWrap variant="subtitle2">
                  {t("create.newSurvey")}
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Paper>
      <SurveyDialog open={dialog.open} handleClose={handleClose} />
    </div>
  );
}

export default AddSurvey;
